import Rest from '../Rest'

export default class LegalEntitySponsorService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/legal_entity_sponsors'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
